/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-track-commerce.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-track-commerce.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
  (function () {
    'use strict';
    window.AOAM_TC_BUILD = '2026-11-03.w5';   /* W5 cart audit A-007 B-021 E-005 */

    /* ---- deferred gtag, same shape as kit-builder.js and the menu tracker ----------------
       This snippet is rendered before content_for_header, so gtag does not exist yet. Queue
       until the GA4 container registers, cap the wait at 20s, and always flush on pagehide
       because a cart add is usually followed by a navigation. */
    var q = [], timer = null, start = Date.now(), sent = 0;
    function ready() {
      try {
        var g = window.google_tag_manager;
        if (!g) return false;
        for (var k in g) if (k.indexOf('G-') === 0) return true;
      } catch (e) {}
      return false;
    }
    function flush(force) {
      try {
        if (!force && !ready() && Date.now() - start < 20000) return;
        if (timer) { clearInterval(timer); timer = null; }
        while (q.length) {
          var e = q.shift();
          try { if (typeof window.gtag === 'function') window.gtag('event', e.n, e.p); } catch (_) {}
        }
      } catch (e) {}
    }
    function ga(name, params) {
      try {
        if (sent > 60) return;
        sent++;
        var p = params || {};
        p.page_type = pageType();
        q.push({ n: name, p: p });
        if (ready() || Date.now() - start >= 20000) { flush(true); return; }
        if (!timer) timer = setInterval(flush, 250);
      } catch (e) {}
    }
    window.addEventListener('pagehide', function () { flush(true); }, true);

    function path() { try { return location.pathname || ''; } catch (e) { return ''; } }
    function pageType() {
      var p = path();
      if (p.indexOf('/products/') === 0) return 'product';
      if (p.indexOf('/collections/') === 0) return 'collection';
      if (p.indexOf('/pages/kit-builder') === 0) return 'kit_builder';
      if (p === '/cart' || p.indexOf('/cart') === 0) return 'cart';
      if (p === '/' || p === '') return 'home';
      if (p.indexOf('/search') === 0) return 'search';
      if (p.indexOf('/blogs/') === 0) return 'blog';
      if (p.indexOf('/pages/') === 0) return 'page';
      return 'other';
    }
    function clean(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, 80); }
    function handleOf(href) {
      try {
        var m = String(href || '').match(/\/products\/([^/?#]+)/);
        return m ? m[1] : '';
      } catch (e) { return ''; }
    }

    function stickyMark() { try { return document.documentElement.dataset.aoamAddSrc === 'sticky_atc'; } catch (e) { return false; } }
    /* 2026-11-03 W5 cart audit E-005: a saved-cart link (/?rc=...) re-adds its lines from code, with no tap. Those adds are a
       restore, not new adds: until the shopper's first click (capped at 20s) they send ONE cart_restored event instead of an
       aoam_cart_add per line. Roll back: delete RESTORE and the restore test in onCartRequest. */
    var RESTORE = { on: false, until: 0, sent: false };
    try { RESTORE.on = /[?&]rc=/.test(location.search || ''); RESTORE.until = Date.now() + 20000; } catch (e) {}
    function addQty(body) {
      try {
        if (body == null) return 1;
        if (typeof body === 'string') {
          var t = body.trim();
          if (t.charAt(0) === '{') {
            var j = JSON.parse(t), list = j.items || [j], q = 0;
            for (var i = 0; i < list.length; i++) q += (list[i] && list[i].quantity != null) ? (+list[i].quantity || 0) : 1;
            return q;
          }
          var m = t.match(/(?:^|&)quantity=(\d+)/);
          return m ? +m[1] : 1;
        }
        if (typeof FormData === 'function' && body instanceof FormData) return +(body.get('quantity') || 1) || 1;
        if (typeof URLSearchParams === 'function' && body instanceof URLSearchParams) return +(body.get('quantity') || 1) || 1;
      } catch (e) {}
      return 1;
    }

    var fired = {};
    function once(key) { if (fired[key]) return false; fired[key] = 1; return true; }

    /* ---- surface of the last click ------------------------------------------------------
       Deliberately derived from WHERE the shopper clicked, not from an add-to-cart button
       selector. This site has at least five distinct add-to-cart controls (PDP form, sticky
       bar, quick view, cart upsell cards, Kit Builder) and they do not share a class. A
       container is stable; a button class is not. */
    var lastClick = { surface: '', at: 0 };
    function surfaceOf(el) {
      try {
        if (!el || !el.closest) return 'other';
        if (el.closest('#header-navigation, #mobile-navigation')) return 'menu';
        if (el.closest('[data-kb-root], .kit-builder, #kit-builder, [data-kb-checkout]')) return 'kit_builder';
        if (pageType() === 'kit_builder') return 'kit_builder';
        /* 2026-09-28 cart-fix-l low-drawer-clean C111: the drawer's accessory rail (.accessory-block-pro-list, no "upsell" class) and the warranty
           row both fell through to 'cart_drawer'. They now report as 'drawer_upsell' and 'warranty' (NEW aoam_cart_add
           event_label values; 'cart_upsell' still means the PDP rail, 'cart_drawer' keeps drawer qty/other adds). No watcher
           reads aoam_cart_add labels. Rollback: delete the two lines below. */
        if (el.closest('.aoam-wb')) return 'warranty';
        if (el.closest('.accessory-block-pro-list')) return 'drawer_upsell';
        if (el.closest('.aoam-upsell-card, [data-aoam-upsell], [class*="upsell"]')) return 'cart_upsell';
        if (el.closest('[data-cart-drawer], #CartDrawer, .cart-drawer, .drawer-cart, [data-header-cart]')) return 'cart_drawer';
        if (el.closest('[class*="sticky"]')) return 'sticky_atc';
        if (el.closest('[class*="quick-view"], [class*="quickview"], [class*="quick_view"]')) return 'quick_view';
        if (el.closest('form[action*="/cart/add"]')) return 'pdp';
        if (pageType() === 'product') return 'pdp';
        return 'other';
      } catch (e) { return 'other'; }
    }

    document.addEventListener('click', function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        /* 2026-11-03 W5 cart audit A-007: under 1081px the sticky bar presses the PDP form's own button, so the click lands
           inside the form and read as pdp. aoam-il-sticky-atc.js marks <html data-aoam-add-src="sticky_atc"> for 1.5s around
           that press; honour it first. Roll back: back to surfaceOf(e.target) alone. */
        lastClick = { surface: stickyMark() ? 'sticky_atc' : surfaceOf(e.target), at: Date.now() };

        /* view_cart: opening the drawer from the header. The /cart page itself is handled on load.
           2026-09-28 cart-fix-m C107: where the site drawer (#header_minicart) exists, view_cart now comes
           from the drawer actually opening (watchDrawer below), once per open, so an auto-open after an add
           counts and a tap INSIDE the drawer no longer does. The click path stays only where there is no
           site drawer (the Kit Builder layout). Rollback: delete the "!document.getElementById" test. */
        var cartOpen = e.target.closest('[data-header-cart-trigger], [data-header-cart], a[href="/cart"], a[href$="/cart"], [class*="cart-toggle"], [class*="cart-trigger"]');
        if (cartOpen && !document.getElementById('header_minicart') && once('view_cart')) {
          ga('view_cart', { event_category: 'cart', event_label: 'drawer' });
        }

        /* 2026-09-28 cart-fix-m C110: warranty opt-in taps on the site cart row
           (snippets/extended-warranty-cartLevel.liquid, whose buttons call aoamWarrTap). Capture phase, so
           the buttons' own stopPropagation cannot hide it. label on | off, item = the price shown.
           Rollback: delete this block. */
        var wb = e.target.closest('.aoam-wb .aoam-wb__btn, .aoam-wb .aoam-wb__rm');
        if (wb) {
          var wr = wb.closest('.aoam-wb'), wOn = wb.classList.contains('aoam-wb__btn');
          var wp = wr && wr.querySelector('.protection_total_price');
          warrEv(wr && wr.closest('#header_minicart') ? 'site_drawer' : 'site_cart_page', wOn ? 'on' : 'off', wp && wp.textContent);
        }

        /* select_item: a product-card click. Anywhere that is NOT already a product page, and NOT
           inside either header menu, because those emit menu_click and would double-count. */
        var a = e.target.closest('a[href*="/products/"]');
        if (a && pageType() !== 'product' && !e.target.closest('#header-navigation, #mobile-navigation')) {
          var h = handleOf(a.getAttribute('href'));
          if (h) {
            /* 2026-09-24 (Claude) - the first day of data returned labels like "NEW",
               "View product" and "View this kit", because a product card's anchor often wraps a
               badge or a CTA rather than the title. The handle is already in item/item_id, but a
               label nobody can read makes the report useless at a glance, so fall back to the
               handle whenever the anchor text is a generic badge or call to action. */
            var at = clean(a.textContent);
            if (!at || at.length < 4 || /^(new|sale|sold ?out|shop|buy|view|learn|more|details)\b/i.test(at)) at = h;
            ga('select_item', {
              event_category: 'card_' + pageType(),
              event_label: at,
              item: h,
              item_id: h
            });
          }
        }
      } catch (_) {}
    }, true);

    /* ---- view_cart on the cart page ----------------------------------------------------- */
    if (pageType() === 'cart' && once('view_cart')) {
      ga('view_cart', { event_category: 'cart', event_label: 'page' });
    }

    /* ---- 2026-09-28 cart-fix-m C110: warranty_optin (shown | on | off) -------------------------
       One GA4 event, event_category = the surface (site_drawer | site_cart_page | saber_lab; the Kit
       Builder sends its own from kb6), event_label = shown | on | off, item = the price shown. Every
       param is already a registered dimension. The same fact goes to Clarity as a custom event
       (warranty_shown / warranty_on / warranty_off) so recordings can be filtered on it.
       Observe only: nothing here changes the cart. Rollback: delete this block and its two callers. */
    function warrEv(surface, act, price) {
      try {
        ga('warranty_optin', { event_category: surface, event_label: act, item: clean(price) });
        if (typeof window.clarity === 'function') { window.clarity('event', 'warranty_' + act); window.clarity('set', 'warranty_' + act, surface); }
      } catch (e) {}
    }

    /* ---- 2026-09-28 cart-fix-m C107 + C110: view_cart and 'shown' per DRAWER OPEN ---------------
       Every add opens the drawer from code (aoam-cart-fix.liquid applyDrawerOpen, or theme.js Drawer),
       never from a click, so the click-based view_cart above missed the main path and fired on the first
       tap INSIDE the drawer instead. Both openers put js-drawer-open on #header_minicart, so this fires
       once per closed->open edge of that class, labelled auto_add (a good /cart/add in the last 10s),
       header (a cart-icon tap in the last 3s) or other. Up to ~8s later, once the warranty offer row is visible
       and not taken, it records warranty_optin 'shown'. Rollback: delete this block. */
    var lastAddAt = 0, drawerWasOpen = false, lastHdrTap = 0, drawerOpens = 0;
    document.addEventListener('click', function (e) {
      try { if (e.target && e.target.closest && e.target.closest('[data-header-cart-trigger], a.js-drawer-open-right, .block-mincart .cstm_icon')) lastHdrTap = Date.now(); } catch (_) {}
    }, true);
    function drawerIsOpen(d) { try { return !!(d && d.classList.contains('js-drawer-open')); } catch (e) { return false; } }
    function onDrawerMaybeOpened(d) {
      try {
        var open = drawerIsOpen(d);
        if (open && !drawerWasOpen) {
          var now = Date.now();
          var lbl = (now - lastAddAt < 10000) ? 'auto_add' : (now - lastHdrTap < 3000) ? 'header' : 'other';
          ga('view_cart', { event_category: 'cart', event_label: lbl });
          var openId = ++drawerOpens, tries = [1200, 3000, 6000];
          var look = function () {
            try {
              if (openId !== drawerOpens || !drawerIsOpen(d)) return;
              var row = d.querySelector('.aoam-wb'), cb = row && row.querySelector('.protection_product_checkbox');
              var wp = row && row.querySelector('.protection_total_price');
              if (cb && cb.checked) return;
              if (!row || row.classList.contains('hide') || !row.getClientRects().length || !wp || !clean(wp.textContent)) {
                if (tries.length) setTimeout(look, tries.shift() - 1200);   /* the row fills after the add lands */
                return;
              }
              warrEv('site_drawer', 'shown', wp.textContent);
            } catch (_) {}
          };
          setTimeout(look, tries.shift());
        }
        drawerWasOpen = open;
      } catch (e) {}
    }

    /* Saber Lab (assets/saber-lab.js renders its warranty toggle into the static #warrHost). 'shown' once
       per page the first time the offer is rendered unticked; on | off on each change of its checkbox.
       No change to the minified bundle. */
    var slShown = false;
    function slPrice(h) { try { var m = String(h.textContent || '').match(/[$\u00a3\u20ac][\d.,]+|[\d.,]+\s?[$\u00a3\u20ac]/); return m ? m[0] : ''; } catch (e) { return ''; } }
    function watchSaberLab() {
      try {
        var h = document.getElementById('warrHost');
        if (!h) return;
        var check = function () {
          try {
            var i = h.querySelector('input[type="checkbox"]');
            if (!slShown && i && !i.checked && h.getClientRects().length) { slShown = true; warrEv('saber_lab', 'shown', slPrice(h)); }
          } catch (_) {}
        };
        if (typeof MutationObserver === 'function') new MutationObserver(check).observe(h, { childList: true });
        check();
        h.addEventListener('change', function (e) {
          try { var t = e.target; if (t && t.type === 'checkbox') warrEv('saber_lab', t.checked ? 'on' : 'off', slPrice(h)); } catch (_) {}
        }, true);
      } catch (e) {}
    }
    function watchDrawer() {
      try {
        watchSaberLab();
        var d = document.getElementById('header_minicart');
        if (!d || typeof MutationObserver !== 'function') return;
        drawerWasOpen = drawerIsOpen(d);
        new MutationObserver(function () { onDrawerMaybeOpened(d); }).observe(d, { attributes: true, attributeFilter: ['class'] });
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();

    /* ---- a REAL cart add, observed on the network ---------------------------------------
       Watching POST /cart/add.js rather than a click means a failed add is never counted as a
       success, and an add fired by code we did not write (Kit Builder, an upsell app) is still
       captured. The surface is whatever the shopper last clicked within the previous 6 seconds. */
    function onCartRequest(url, ok, qty) {
      try {
        var u = String(url || '');
        if (u.indexOf('/cart/add') < 0) return;
        if (RESTORE.on && !lastClick.at && Date.now() < RESTORE.until) {
          if (ok && !RESTORE.sent) { RESTORE.sent = true; ga('cart_restored', { event_category: 'cart', event_label: 'rc_link' }); }
          return;
        }
        var s = (Date.now() - lastClick.at < 6000 && lastClick.surface) ? lastClick.surface : (stickyMark() ? 'sticky_atc' : 'unknown');
        var p = { event_category: ok ? 'cart_add' : 'cart_add_failed', event_label: s };
        if (qty != null) p.quantity = qty;
        ga('aoam_cart_add', p);
        /* B-021 hook for other trackers (Clarity): one logical add, with its qty. */
        try { document.dispatchEvent(new CustomEvent('aoam:add', { detail: { ok: !!ok, surface: s, quantity: qty == null ? 1 : qty } })); } catch (x) {}
      } catch (e) {}
    }

    /* 2026-11-03 W5 cart audit B-021: this wrapper sits INSIDE aoam-cart-fix.js's fetch wrapper (rendered later in
       head-scripts), so a repeat add that aoamMergedAdd turns into /cart/change.js never reached it. An OUTER layer,
       installed at DOMContentLoaded above everything else, now counts each logical /cart/add once with its qty; this inner
       one stands down for any add the outer layer is carrying (init marked, or an outer add still in flight) and keeps
       counting adds nothing outer saw (XHR, early callers). Roll back: delete the outer block and the outerOn tests. */
    var outerOn = false, outerPending = 0, innerFetch = null;
    function outerHas(init) { try { return outerOn && (outerPending > 0 || !!(init && init.__aoamTrk)); } catch (e) { return false; } }
    try {
      var of_ = window.fetch;
      if (typeof of_ === 'function') {
        window.fetch = innerFetch = function (input, init) {
          var u = '';
          try { u = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
          var method = '';
          try { method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase(); } catch (e) {}
          try { if (method === 'POST' && u.indexOf('/cart/add') >= 0) lastAddAt = Date.now(); } catch (e) {}   // 2026-09-28 cart-fix-m C107: labels an auto-open. Rollback: delete this line.
          var r = of_.apply(this, arguments);
          try {
            if (method === 'POST' && r && r.then && !(u.indexOf('/cart/add') >= 0 && outerHas(init))) {
              var q0 = (u.indexOf('/cart/add') >= 0) ? addQty(init && init.body) : null;
              r.then(function (res) { onCartRequest(u, res && res.ok, q0); }, function () { onCartRequest(u, false, q0); });
            }
          } catch (e) {}
          return r;
        };
      }
    } catch (e) {}

    function installOuter() {
      try {
        var cur = window.fetch;
        if (outerOn || typeof cur !== 'function' || !innerFetch || cur === innerFetch) return;
        outerOn = true;
        window.fetch = function (input, init) {
          var u = '', method = '';
          try { u = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
          try { method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase(); } catch (e) {}
          var isAdd = false;
          try { isAdd = method === 'POST' && String(u).indexOf('/cart/add') >= 0; } catch (e) {}
          if (!isAdd) return cur.apply(this, arguments);
          var q = addQty(init && init.body);
          lastAddAt = Date.now();
          try { if (init && typeof init === 'object') Object.defineProperty(init, '__aoamTrk', { value: 1, configurable: true }); } catch (e) {}
          outerPending++;
          var r;
          try { r = cur.apply(this, arguments); } catch (e) { outerPending--; throw e; }
          try {
            if (r && r.then) r.then(function (res) { outerPending--; onCartRequest(u, res && res.ok, q); }, function () { outerPending--; onCartRequest(u, false, q); });
            else outerPending--;
          } catch (e) { outerPending--; }
          return r;
        };
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installOuter); else installOuter();

    try {
      var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) {
        try { this.__aoamTrkU = u; this.__aoamTrkM = String(m || '').toUpperCase(); } catch (e) {}
        return xo.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        try {
          var x = this;
          if (x.__aoamTrkM === 'POST' && x.__aoamTrkU) {
            if (String(x.__aoamTrkU).indexOf('/cart/add') >= 0) lastAddAt = Date.now();   // 2026-09-28 cart-fix-m C107. Rollback: delete this line.
            var xq = (String(x.__aoamTrkU).indexOf('/cart/add') >= 0) ? addQty(arguments[0]) : null;
            x.addEventListener('loadend', function () {
              onCartRequest(x.__aoamTrkU, x.status >= 200 && x.status < 400, xq);
            });
          }
        } catch (e) {}
        return xs.apply(this, arguments);
      };
    } catch (e) {}

    /* ---- sign_up: Klaviyo form submits --------------------------------------------------
       Uses Klaviyo's own documented klaviyoForms window event, so it survives any change to the
       form markup and covers the popup, the footer form and the back-in-stock form alike. */
    window.addEventListener('klaviyoForms', function (e) {
      try {
        var d = e && e.detail;
        if (!d) return;
        if (d.type === 'submit') {
          ga('sign_up', { event_category: 'klaviyo', event_label: clean(d.formId) || 'form' });
        } else if (d.type === 'open') {
          ga('aoam_form_open', { event_category: 'klaviyo', event_label: clean(d.formId) || 'form' });
        }
      } catch (_) {}
    });
  })();
